<div class="form-account">
  <h3 class="text-center">Welcome! Tell us who you are...</h3>
  <p class="mb-0 text-center text-secondary">We need some of your personal data in order to continue</p>
  <!-- Spinner -->
  @if (isLoading) {
    <div class="spinner">
      <i class="fad fa-spinner-third fa-spin"></i>
    </div>
  }
  <form class="row justify-content-center form-account_user-form form-group" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="col-6">
      <div class="row gap-3">
        @for (input of formInputs; track input.controlName) {
          <div class="col-12">
            <xen-input
              [formGroup]="form"
              [type]="input.type"
              [label]="input.label"
              [id]="input.controlName"
              [formControlName]="input.controlName"
              [required]="true"
              [disabled]="false"
              [validation]="true"
              [validation_status]="controlStatus(input.controlName)"
              [placeholder]="input.placeholder"
              [feedback]="controlInvalid(input.controlName) ? controlError(input.controlName) : ''"
              [icon]="false"
              [icon_placement]="right"
            ></xen-input>
          </div>
        }
        @for (check of formChecks; track check.controlName) {
          <div [formGroup]="form" class="col-12">
            <xen-checkbox
              [checked]="false"
              [disabled]="false"
              [label]="check.text"
              [id]="check.controlName"
              [formControlName]="check.controlName"
              [validation]="true"
              [validation_status]="controlInvalid(check.controlName) ? 'is-invalid' : ''"
              [feedback]="controlInvalid(check.controlName) ? controlError(check.controlName) : ''"
            ></xen-checkbox>
          </div>
        }
        <div class="mb-4 col-12">
          <xen-btn
            type="primary"
            size="large"
            label="Continue"
            [full_width]="true"
            [icon]="true"
            icon_snippet="fal fa-chevron-right"
            icon_placement="right"
            (click)="onSubmit()"
            [id]="'signup-create-user'"
          ></xen-btn>
        </div>
      </div>
    </div>
  </form>
  <p class="text-center sign-up-text">
    Already have a Travelgate account? <a href="https://app.travelgate.com/">Login</a>
  </p>
</div>
